import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as Yup from "yup";
import { useHistory } from "react-router";

const EditCouncilProfile = ({ data, CouncilProfile }) => {
  const [errMsg, setErrMsg] = useState(false);
  const history = useHistory();

  return (
    <div className="edit-profile">
      <div className="edit-profile-box">
        <div className="title">
          <h2>Edit Council Profile</h2>
        </div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            name: `${
              data && data.users[0] && data.users[0].council_profile.name
                ? data.users[0].council_profile.name
                : ""
            }`,
            email: `${
              data && data.users[0] && data.users[0].council_profile.email
                ? data.users[0].council_profile.email
                : data && data.users[0] && data.users[0].email
                ? data.users[0].email
                : ""
            }`,
            phone: `${
              data &&
              data.users[0] &&
              data.users[0].council_profile.mobile_number
                ? data.users[0].council_profile.mobile_number
                : ""
            }`,
            website: `${
              data && data.users[0] && data.users[0].council_profile.website
                ? data.users[0].council_profile.website
                : ""
            }`,
            description: `${
              data?.users?.length > 0 &&
              data.users[0] &&
              data.users[0].council_profile.description
                ? data.users[0].council_profile.description
                : "" 
            }`,
            address: `${
              data && data.users[0] && data.users[0].council_profile.state
                ? data.users[0].council_profile.state
                : ""
            }`,
          }}
          validationSchema={Yup.object({
            email: Yup.string().email("Invalid Email Address"),
            website: Yup.string().matches(
              /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
              "Please Enter Valid URL"
            ),
            phone: Yup.string().matches(
              /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/,
              "Enter a Valid Australian Phone Number"
            ),
            description: Yup.string().required("Please enter the description"),
          })}
          onSubmit={(values) => {
            if (values.description) {
              if (/^\s*$/.test(values.description)) {
                //only spaces in the value
                setErrMsg(true);
              } else {
                setErrMsg(false);
                CouncilProfile({
                  variables: {
                    data: {
                      email: values.email,
                      mobile_number: values.phone,
                      website: values.website,
                      description: values.description,
                      state: values.address,
                      name: values.name,
                    },
                    user_id: `${
                      data && data.users[0] && data.users[0].id
                        ? data.users[0].id
                        : ""
                    }`,
                  },
                })
                  .then(() => {
                    history.push("/council-profile");
                    // setSubmitting(false);
                  })
                  .catch(() => {
                    // setSubmitting(false);
                  });
              }
            }
          }}
        >
          {/* {({ isSubmitting }) => ( */}
            <Form>
              <div style={{ width: "49%" }}>
                <div className="form-group full-width">
                  <label>Name</label>
                  <Field
                    type="name"
                    name="name"
                    className="form-control"
                    style={{ backgroundColor: "white" }}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group full-width">
                  <label>Phone</label>
                  <Field type="phone" name="phone" className="form-control" />
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group full-width">
                  <label>Website</label>
                  <Field type="text" name="website" className="form-control" />
                  <ErrorMessage
                    name="website"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group full-width">
                  <label>State</label>
                  <Field type="text" name="address" className="form-control" />
                  <ErrorMessage
                    name="address"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <div style={{ width: "49%" }}>
                <div className="form-group full-width">
                  <label>Email</label>
                  <Field type="email" name="email" className="form-control" />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </div>
                <div className="form-group full-width">
                  <label>Description</label>
                  <Field
                    type="text"
                    component="textarea"
                    name="description"
                    className="form-control"
                    rows="7"
                    // cols="50"
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="error-message"
                  />
                  {errMsg && (
                    <div className="error-message">
                      Please enter a valid descritpion
                    </div>
                  )}
                </div>
              </div>
              <div className="submit">
                <button
                  type="submit"
                  // disabled={isSubmitting}
                  className="submit-btn"
                >
                  Save Changes
                </button>
              </div>
            </Form>
          {/* )} */}
        </Formik>
      </div>
    </div>
  );
};

export default EditCouncilProfile;
